import { FC } from 'react';
import styled from 'styled-components';
import { ExternallyManagedIndicator } from 'externallyManaged/ExternallyManagedIndicator';
import { WithUncontrolledPopover } from '@ardoq/popovers';
import { LinkDecorator } from '@ardoq/decorators';
import { colors } from '@ardoq/design-tokens';
import { ArdoqId, WorkspaceIntegration } from '@ardoq/api-types';
import { workspaceInterface } from '@ardoq/workspace-interface';
import {
  isAvailableIntegrationSource,
  navigateToIntegrationBySource,
} from 'integrations/common/navigation/utils';
import { t, type I18nLocale } from '@ardoq/i18n';

const { getWorkspaceIntegrations } = workspaceInterface;

type ExternallyManagedNavigatorIndicatorProps = {
  readonly workspaceId: ArdoqId;
  readonly i18nLocale: I18nLocale;
};
type IntegrationsProps = {
  readonly integrations: WorkspaceIntegration[];
  readonly i18nLocale: I18nLocale;
};

const IntegrationsWrapper = styled.div`
  width: 300px;
  color: ${colors.grey700};
  pointer-events: auto;
`;

const Integrations: FC<IntegrationsProps> = ({ integrations, i18nLocale }) => (
  <IntegrationsWrapper>
    <div>
      <div>
        {t(
          i18nLocale,
          'externallyManaged:popover.managedBy',
          'This workspace is managed by:'
        )}
      </div>
      {integrations.map(({ _id, name, type }) => (
        <div key={_id}>
          {isAvailableIntegrationSource(type) ? (
            <LinkDecorator
              hideIcon
              href=""
              onClick={() => {
                navigateToIntegrationBySource(type);
              }}
            >
              {name}
            </LinkDecorator>
          ) : (
            name
          )}
        </div>
      ))}
    </div>
    <br />
    <div>
      {t(
        i18nLocale,
        'externallyManaged:popover.note',
        'Note: Changes on populating components may be overwritten'
      )}
    </div>
  </IntegrationsWrapper>
);

const ExternallyManagedIndicatorWithPopover: FC<
  ExternallyManagedNavigatorIndicatorProps
> = ({ workspaceId, i18nLocale }) => (
  <WithUncontrolledPopover
    content={() => (
      <Integrations
        integrations={getWorkspaceIntegrations(workspaceId)}
        i18nLocale={i18nLocale}
      />
    )}
  >
    <span style={{ cursor: 'pointer' }}>
      <ExternallyManagedIndicator i18nLocale={i18nLocale} />
    </span>
  </WithUncontrolledPopover>
);

export { ExternallyManagedIndicatorWithPopover };
